import React from 'react';
import { Link } from '@ambiguous/link';
export default function CardSimple({ content, image, title, url, url__props }) {
    const { alt, id, url: src } = image || {};
    const CardContent = () => (React.createElement("div", { className: "ltg-card" },
        React.createElement("div", { className: "ltg-card-img-wrap" },
            React.createElement("img", { src: src, alt: alt || title, className: "ltg-card-img" })),
        title && (React.createElement("h4", { className: "ltg-card-title" }, title)),
        content && (React.createElement("div", { className: "ltg-card-content", dangerouslySetInnerHTML: { __html: content } }))));
    if (url) {
        return (React.createElement(Link, { href: url, target: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? '_blank' : null, rel: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? 'noreferrer nofollow' : null, className: "ltg-card-simple" },
            React.createElement(CardContent, null)));
    }
    return (React.createElement("div", { className: "ltg-card-simple" },
        React.createElement(CardContent, null)));
}
